import { IEvent } from "@services/event.services";
import * as angular from "angular";
import "./fleetEventBar.component.scss";

interface IComponentBindings {
    label: string;
    segments: IEventBarSegment<any>[];
    total: number;
    maxTotal: number;

    hideTotal: boolean;
    showSegmentCount: boolean;
}

export interface IEventBar {
    id: string;
    dataId?: number | string; // used to filter ng-repeat against a filtered DriverId / VehicleId and so on
    label: string;
    segments: IEventBarSegment<any>[];
    total: number;
    maxTotal: number;
    sticky?: boolean; // used for showing the bar in ng-repeats when filtering other stuff like a specific driver OR sticky
}

export interface IEventBarSegment<T> {
    id: number;

    total?: number;
    color: string;
    label: string;

    events?: T[];

    tooltip?: string;
    width?: number;
}

class Controller implements angular.IComponentController, IComponentBindings {
    label: string;
    segments: IEventBarSegment<any>[];

    total: number;
    maxTotal: number;
    totalWidth = 0;

    faded: boolean = false;

    hideTotal: boolean;
    showSegmentCount: boolean;

    static $inject = [];

    constructor() {
    }

    $onInit(): void {
    }

    $onChanges() {
        this.totalWidth = 0;

        this.segments.forEach(segment => {
            const maxTotalSegmentPercentage = segment.events.length / this.maxTotal * 100;

            const thisSegmentPercentage = segment.events.length / this.total * 100;
            var thisSegmentValue = this.showSegmentCount ? segment.events.length : thisSegmentPercentage;

            this.totalWidth += maxTotalSegmentPercentage;
            segment.width = thisSegmentPercentage;

            segment.tooltip = `${segment.label} (${Math.round(thisSegmentValue)}${this.showSegmentCount ? "" : "%"})`;
        });

        this.updateFadedFromTotal();
    }

    // ---

    private updateFadedFromTotal(): void {
        this.faded = this.total < 1;
    }
}

export class FleetEventBarComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            label: "<",
            segments: "<",

            total: "<",
            maxTotal: "<",

            sticky: "<",

            hideTotal: "<?",
            showSegmentCount: "<?"
        };

        this.controller = Controller;
        this.template = require("./fleetEventBar.component.html");
    }
}
